'use client'

import { useTranslations } from 'next-intl'
import { Check, Languages } from 'lucide-react'
import Flag from 'react-flagkit'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { setUserLocale } from '@/i18n/service'
import type { Locales } from '@/types/meta'

type PropsType = {
  locales: Locales
  locale: string
}

const LanguageSwitcher = ({ locales, locale }: PropsType) => {
  const t = useTranslations()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <Languages />
          <span className="sr-only">{t('select_language')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {locales.map(l => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setUserLocale(`${l.code}-${l.countryCode}`)}
            className="flex flex-row justify-between gap-2">
            <div className="flex flex-row items-center justify-start gap-2">
              <Flag country={l.countryCode} size={12} />
              <span>{`${l.name}`}</span>
            </div>
            {locale === `${l.code}-${l.countryCode}` && <Check className="h-4 w-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default LanguageSwitcher
